import { get, patch } from '../../api/api';
import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';

export const obtemSourcesGlobais = async (): Promise<IRespostaFuncao<any>> => {
  return await get<IRespostaFuncao<any>>('/sources-globais');
};

export const atualizarSourceGlobalAtivo = async (payload: { source: 'pgfarma' | 'iqvia' | 'closeup'; ativo: boolean }): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>('/sources-globais/atualiza-global-ativo', payload);
};
